.radio-group {
  &.radio-group--full-width {
    width: 100%;
  }
}
